function initConcernFilter(root) {
  if (root.dataset.concernFilterInit === 'true') return;
  root.dataset.concernFilterInit = 'true';

  const tabs = root.querySelectorAll('[data-tab-value]');
  const cards = root.querySelectorAll('[data-tab]');
  const tabsWrap = root.querySelector('.custom-concern__tabs');

  // --- Drag-to-scroll for mouse (desktop) ---
  if (tabsWrap) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    tabsWrap.addEventListener('mousedown', (e) => {
      isDown = true;
      moved = false;
      tabsWrap.classList.add('is-dragging');
      startX = e.pageX - tabsWrap.offsetLeft;
      scrollLeft = tabsWrap.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach((evt) => {
      tabsWrap.addEventListener(evt, () => {
        isDown = false;
        tabsWrap.classList.remove('is-dragging');
      });
    });

    tabsWrap.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tabsWrap.offsetLeft;
      const walk = (x - startX) * 1.2; // drag speed multiplier
      if (Math.abs(walk) > 5) moved = true;
      tabsWrap.scrollLeft = scrollLeft - walk;
    });

    // Prevent accidental tab-click right after a drag
    tabsWrap.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.stopPropagation();
          e.preventDefault();
        }
      },
      true
    );
  }

  function applyFilter(value) {
    tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.tabValue === value);
    });

    cards.forEach((card) => {
      const matches = card.dataset.tab === value;
      card.style.display = matches ? '' : 'none';
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      applyFilter(tab.dataset.tabValue);
    });
  });

  if (tabs.length > 0) {
    applyFilter(tabs[0].dataset.tabValue);
  }
}

function initAllConcernFilters() {
  document.querySelectorAll('.custom-concern').forEach(initConcernFilter);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllConcernFilters);
} else {
  initAllConcernFilters();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.custom-concern').forEach(initConcernFilter);
});

document.addEventListener('submit', async function (event) {
  const form = event.target.closest('[data-add-to-cart]');
  if (!form) return;
  if (!form.closest('.custom-concern')) return;

  event.preventDefault();

  const button = form.querySelector('.custom-concern__add-btn');
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer) return;

  button.disabled = true;

  try {
    const formData = new FormData(form);

    formData.append(
      'sections',
      cartDrawer.getSectionsToRender().map((section) => section.id)
    );

    formData.append('sections_url', window.location.pathname);

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Unable to add product');
    }

    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(data);

  } catch (error) {
    console.error('Add to cart error:', error);
  }

  button.disabled = false;
});